import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import namanImg from '../images/division_naman_enterprises.webp';

const Wrapper = styled.div`
  min-height: 80vh;
  padding: calc(var(--headerHeight) + 60px) 5% 80px;
  background: linear-gradient(135deg, #070b13 0%, #0b1424 100%);
  color: #faf9f6;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  max-width: 1200px;
  width: 100%;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 60px;
  align-items: center;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const BadgeRow = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const Badge = styled.span`
  background: rgba(212, 175, 55, 0.12);
  border: 1px solid rgba(212, 175, 55, 0.25);
  color: #d4af37;
  padding: 8px 16px;
  border-radius: 30px;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

const Title = styled.h1`
  font-size: clamp(2.2rem, 4vw, 3rem);
  font-weight: 800;
  background: linear-gradient(135deg, #ffffff 0%, #d4af37 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
`;

const Subtitle = styled.p`
  font-size: 1.15rem;
  line-height: 1.7;
  color: #cfc9be;
  margin: 0;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const ListItem = styled.li`
  font-size: 0.95rem;
  color: #faf9f6;
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: "✦";
    color: #d4af37;
    font-size: 0.9rem;
  }
`;

const ContactCard = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  p {
    margin: 0;
    font-size: 0.95rem;
    color: #cfc9be;
  }

  strong {
    color: #d4af37;
  }
`;

const ActionRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 12px;
`;

const PrimaryButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 28px;
  background: linear-gradient(135deg, #e8c547 0%, #d4af37 100%);
  color: #0b0f19;
  font-weight: 700;
  border-radius: 30px;
  text-decoration: none;
  box-shadow: 0 8px 20px rgba(212, 175, 55, 0.2);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 28px rgba(212, 175, 55, 0.35);
  }
`;

const SecondaryButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 28px;
  background: transparent;
  color: #ffffff;
  font-weight: 600;
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: #ffffff;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.08);
  aspect-ratio: 16/10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.02);
  padding: 16px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 12px;
  }
`;

export default function NamanPage() {
  return (
    <Wrapper>
      <Container>
        <InfoSection>
          <BadgeRow>
            <Badge>15+ Years Trust</Badge>
            <Badge>Industrial Fuel Trading</Badge>
          </BadgeRow>
          <Title>Naman Enterprises</Title>
          <Subtitle>
            A premier trading partner dealing in L.D.O., Furnace Oil, and industrial fuels. We supply company-direct products from major public/private sector refineries as well as high-grade imported products.
          </Subtitle>
          
          <div style={{ margin: '8px 0' }}>
            <h3 style={{ color: '#d4af37', marginBottom: '14px', fontSize: '1.1rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Products Traded</h3>
            <List>
              <ListItem>Light Diesel Oil (L.D.O.)</ListItem>
              <ListItem>Furnace Oil (F.O.)</ListItem>
              <ListItem>L.S.H.S.</ListItem>
              <ListItem>Fuel Oil</ListItem>
              <ListItem>Pyrolysis Oil</ListItem>
              <ListItem>Refinery Products (IOCL, HPCL, BPCL)</ListItem>
              <ListItem>Nayara & Reliance Products</ListItem>
              <ListItem>Imported Fuel Oils</ListItem>
            </List>
          </div>

          <ContactCard>
            <p><strong>Partnership Range:</strong> Over 15 years serving industrial clients in central India</p>
            <p><strong>Office Phone:</strong> 0712-2762798</p>
            <p><strong>Trade Desk Mobile:</strong> 9970153000 / 8999181685</p>
          </ContactCard>

          <ActionRow>
            <PrimaryButton href="tel:9970153000">Call Trading Desk</PrimaryButton>
            <SecondaryButton to="/">Back to Home</SecondaryButton>
          </ActionRow>
        </InfoSection>

        <ImageContainer>
          <img src={namanImg} alt="Naman Enterprises industrial petroleum trading" />
        </ImageContainer>
      </Container>
    </Wrapper>
  );
}
